import '../sass/main.scss';

import { initializeDarkModeToggle } from './darkModeToggle.js';
import { initSkipLinks } from './skipLinks.js';

document.addEventListener('DOMContentLoaded', function () {
    
    // Initialize the dark mode toggle
    initializeDarkModeToggle('dark-mode-toggle', 'dark-mode');

    // Initialize skip links
    initSkipLinks();
});
